export const PAYROLL_REPORTS_HEADER = "PAYROLL_REPORTS_HEADER";
export const PAYROLL_REPORTS_HEADER_SUCCESS = "PAYROLL_REPORTS_HEADER_SUCCESS";
export const PAYROLL_REPORTS_HEADER_FAIL = "PAYROLL_REPORTS_HEADER_FAIL";

export const RESET_REPORTS = "RESET_REPORTS";
export const RESET_REPORTS_SUCCESS="RESET_REPORTS_SUCCESS";
export const RESET_REPORTS_FAILURE="RESET_REPORTS_FAILURE";
